// React i hookovi
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";

// Tipovi specifični za komponentu
import { VehicleInfoCardProps, VehicleInfoRef } from "./types";

// Pomoćne funkcije i hookovi
import { useTranslate } from "helpers";
import VehicleGalleryPreview from "./components/VehicleGalleryPreview/VehicleGalleryPreview";
import { VehicleGalleryPreviewRef } from "./components/VehicleGalleryPreview/types";
import VehicleLocation from "./components/VehicleLocation/VehicleLocation";
import { VehicleLocation as VehicleLocationType } from "services/api/fleet/vehicles/locations/types";
import VehicleSpecification from "./components/VehicleSpecification/VehicleSpecification";


const VehicleInfoCard = forwardRef<VehicleInfoRef, VehicleInfoCardProps>((props, ref) => {
  const { fleetVehicleDetail, onPictureDeleted, onVehicleRefresh } = props;

  const { t } = useTranslate();

  const galleryPreviewRef = useRef<VehicleGalleryPreviewRef>(null);

  const [localDetail, setLocalDetail] = useState(fleetVehicleDetail);

  useEffect(() => {
    setLocalDetail(fleetVehicleDetail);
  }, [fleetVehicleDetail]);

  useImperativeHandle(ref, () => ({
    refreshGallery: () => galleryPreviewRef.current?.refresh(),
  }));

  const handleMileageUpdate = useCallback((newMileage: number) => {
    setLocalDetail(prev => ({ ...prev, kmTraveled: newMileage }));
  }, []);

  const handleRegistrationUpdate = useCallback((registrationPlate: string, registrationExpiration: Date | null) => {
    setLocalDetail(prev => ({ ...prev, registrationPlate, registrationExpiration }));
  }, []);

  const handleLocationChange = useCallback((location: VehicleLocationType) => {
    setLocalDetail(prev => ({ ...prev, location }));
  }, []);

  return (
    <div>
      <VehicleLocation fleetVehicleDetail={localDetail} onLocationChange={handleLocationChange} onStatusChange={onVehicleRefresh} />
      <VehicleGalleryPreview ref={galleryPreviewRef} fleetVehicleDetail={localDetail} onPictureDeleted={onPictureDeleted} />
      <VehicleSpecification fleetVehicleDetail={localDetail} onMileageUpdate={handleMileageUpdate} onRegistrationUpdate={handleRegistrationUpdate} />

    </div>
  );
});

export default memo(VehicleInfoCard);
